<template>
  <div>
    <div id="map"></div>

    <div class="btns">
      <button class="draw" @click="draw()">绘制</button>
      <button class="disDraw" @click="disDraw()">关闭绘制</button>
    </div>
    <p class="btn" @click="save">保存</p>
  </div>
</template>
  
<script>
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
// leaflet.pm换为leaflet-geoman-free  https://gitee.com/lianggit/leaflet.pm#getting-started
// import "@geoman-io/leaflet-geoman-free";
// import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

// Vue.L = Vue.prototype.$L = L
/* leaflet icon */
// delete L.Icon.Default.prototype._getIconUrl
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// })
export default {
  data() {
    return {
      map: "",
      areaArr: [],
      drawRadius: '',
      // isDrawing: false
    };
  },
  methods: {
    initMap2() {
      // 图片的像素大小
      const imageWidth = 16206;
      const imageHeight = 10078;
      // 瓦片大小
      const tileSize = 256;

      // 计算最大级别
      const maxZoom = Math.ceil(Math.log2(Math.max(imageWidth, imageHeight) / tileSize));

      // 初始化地图
      this.map = L.map('map', {
        maxZoom: maxZoom, // 设置最大缩放级别
        minZoom: 2,       // 设置最小缩放级别
        crs: L.CRS.Simple, // 使用简单坐标系（非地理坐标系）
        // attributionControl: false // 移除右下角leaflet标识
      });

      // 设置地图的初始视图
      const initialCenter = [imageHeight / 2, imageWidth / 2]; // 图片中心点
      const initialZoom = 0; // 初始缩放级别
      this.map.setView(initialCenter, initialZoom);

      // 添加自定义瓦片图层
      L.tileLayer('http://download.dev.tj720.com/tmp/leaflet/tiles/{z}/{x}/{y}.png', {
          tileSize: tileSize,   // 瓦片大小
          noWrap: true,         // 防止瓦片重复
          attribution: 'Custom Tiles', // 自定义属性
      }).addTo(this.map);

      // 设置地图的最大边界
      const southWest = this.map.unproject([0, imageHeight], maxZoom); // 左下角坐标
      const northEast = this.map.unproject([imageWidth, 0], maxZoom);  // 右上角坐标
      const bounds = L.latLngBounds(southWest, northEast);
      this.map.setMaxBounds(bounds); // 限制地图拖动范围

      this.map.pm.setLang('zh')
      this.map.pm.addControls({
        position: "topleft",
        // drawPolygon: false, // 添加绘制多边形
        // drawMarker: false, //添加按钮以绘制标记
        // drawCircleMarker: false, //添加按钮以绘制圆形标记
        // drawPolyline: false, //添加按钮绘制线条
        // drawRectangle:	true,	//添加按钮绘制矩形
        // drawCircle: false, //  添加按钮绘制圆圈
        // editMode: false, //  添加按钮编辑多边形
        // dragMode: true, //   添加按钮拖动多边形
        // cutPolygon: false, // 添加一个按钮以删除图层里面的部分内容
        // removalMode: true  // 清除图层
      })

      this.getlatLngs()
    },
    initMap() {
      // var map = L.map('map', {
      //     zoomSnap: 0,
      //     edgeBufferTiles: 1,
      //     loadingControl: true,
      //     keepBuffer: 2,
      //     updateInterval: 1,
      //     fadeAnimation: true,
      //     zoomAnimation: true,
      //     inertia: true,
      //     inertiaDeceleration: 1000,
      //     crs: L.CRS.Simple
      // });

      // var path = "https://ip.e-dunhuang.com/resources/10.0001/0001/0001/0061/0001/0001/01/9/index_files/";

      // var dzLayer = L.tileLayer.deepzoom(map, path, {
      //   width: 49286,
      //   height: 20338,
      //   imageFormat: 'webp',
      //   tileSize: 1024,
      //   edgeBufferTiles: 1,
      //   updateWhenIdle: false,
      //   keepBuffer: 10,
      //   fadeAnimation: true,
      //   detectRetina: true,
      //   updateInterval: 1,
      //   opacity: 999999,
      //   reuseTiles: true,
      //   unloadInvisibleTiles: false,
      //   attribution: '&copy; 数字敦煌',
      // });
      // map.setMaxZoom(dzLayer.options.maxZoom * 1.0);
      // map.setMinZoom(dzLayer.options.maxZoom * 0.68);

      // dzLayer.addTo(map);



      this.map = L.map('map').setView([40.712216, -74.22655], 14);

      // this.map = L.map('map').setView([0, -74.22655], 13);

      // L.tileLayer('https://ip.e-dunhuang.com/resources/10.0001/0001/0001/0061/0001/0001/01/9/index_files/{z}/{x}_{y}.webp', {
      L.tileLayer('', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      let imageUrl = 'https://www.lnmuseum.com.cn/img/banner-collect.b8a2e3c4.jpg',
      imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
      L.imageOverlay(imageUrl, imageBounds, {
        className: 'map-pic'
      }).addTo(this.map);

      // L.marker([51.5, -0.09]).addTo(this.map)
      //   .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
      //   .openPopup();

      // // 设置绘制后的线条颜色等--不生效
      // // this.map.pm.setPathOptions({
      // //   color: "yellow",
      // //   fillColor: "green",
      // //   fillOpacity: 0.4
      // // });
      // // this.map.pm.enableDraw('Rectangle', {
      // //   pathOptions: {
      // //     color: 'pink',
      // //     fillColor: 'skyblue',
      // //     fillOpacity: 0.4
      // //   }
      // // });
      // this.map.pm.setLang('zh')
      // this.map.pm.addControls({
      //   position: "topleft",
      //   // drawPolygon: false, // 添加绘制多边形
      //   // drawMarker: false, //添加按钮以绘制标记
      //   // drawCircleMarker: false, //添加按钮以绘制圆形标记
      //   // drawPolyline: false, //添加按钮绘制线条
      //   // drawRectangle:	true,	//添加按钮绘制矩形
      //   // drawCircle: false, //  添加按钮绘制圆圈
      //   // editMode: false, //  添加按钮编辑多边形
      //   // dragMode: true, //   添加按钮拖动多边形
      //   // cutPolygon: false, // 添加一个按钮以删除图层里面的部分内容
      //   // removalMode: true  // 清除图层
      // })
      
      this.getlatLngs()
    },
    getlatLngs() {
      // 设置全局路径样式
      // this.map.on('pm:loaded', function() {
      //   this.map.pm.setPathOptions({
      //     color: 'orange',
      //     fillColor: 'yellow',
      //     fillOpacity: 0.4
      //   })
      // });
      //pm:drawstart 开始第一个点的时候调用
      //pm:drawend  禁止绘制时调用
      //pm:create  创建完成时调用
      this.map.on("pm:drawstart", e => {
        console.log(e, "first");

        // if(!this.isDrawing) {
        //   this.map.pm.enableDraw('Rectangle', {
        //     pathOptions: {
        //       color: 'pink',
        //       fillColor: 'skyblue',
        //       fillOpacity: 0.4
        //     }
        //   })
        //   this.isDrawing = true
        // }
      });
      this.map.on("pm:drawend", e => {
        console.log(e, "禁止绘制");
      });
      this.map.on("pm:create", e => {
        console.log(e, "绘制完成时调用");
        console.log(e.layer._latlngs[0], "绘制坐标")
        this.areaArr.push(e.layer._latlngs[0])
      });
    },
    draw() {
      this.map.pm.enableDraw("Rectangle", { 
        snappable: true,
        pathOptions: {
          color: 'pink',
          fillColor: '#fff',
          fillOpacity: 0.1
        }
      });
      //   this.map.pm.enableDraw("Marker", { snappable: false });
      //   this.map.pm.enableDraw("CircleMarker", { snappable: false });
    },
    disDraw() {
      this.map.pm.disableDraw("Rectangle");
      //    this.map.pm.disableDraw('Marker');
      //    this.map.pm.disableDraw('CircleMarker');
    },
    save() {
      console.log(this.areaArr)

      this.drawObj = L.polygon(this.areaArr, { color: "#fff", fillColor: '#fff', fillOpacity: 0.1 }).addTo(this.map);
      // this.drawObj.bindTooltip('this is 个多边形');  //鼠标移上去的提示

      // color：线段颜色
      // weight：线段宽度
      // opacity：线段透明度
      // dashArray：虚线间隔
      // fill：是否填充内部(true/false)
      // fillColor:内部填充颜色，如不设置，默认为color颜色
      // fillOpacity：内部填充透明度
      // 画个圈
    //   this.drawRadius = L.circle([40.0224690112063, 116.51339229202272], {
    //     radius: 200
    //   }).addTo(this.map);
    },
  },
  mounted() {
    this.initMap2()
  },
};
</script>

<style lang="scss" scoped>
#map {
  width: 100%;
  height: calc(100vh);
  z-index: 1;
}
.btn {
  position: absolute;
  z-index: 9;
  top: 10px;
  left: 200px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.btns {
  position: absolute;
  z-index: 9;
  left: 10px;
  bottom: 200px;
  color: blue;
  font-size: 20px;
  cursor: pointer;
}

/deep/ .map-pic {
  object-fit: contain;
}
/deep/ .leaflet-interactive {
  fill: red;
  stroke: yellow;
}
</style>